import type { Place } from './router'

export const DOCS_BASE = 'https://docs.staleless.com/staleless'

export interface ClientGuide {
  title: string
  description: string
  category: 'Start' | 'Write and publish' | 'Manage' | 'Developers'
  path: string
  places: Place[]
}

export const CLIENT_GUIDES: ClientGuide[] = [
  {
    title: 'Start with Staleless',
    description: 'Create a documentation site, write the first page and publish it.',
    category: 'Start',
    path: '/getting-started/quickstart/',
    places: ['home', 'pages'],
  },
  {
    title: 'Import existing documentation',
    description: 'Bring in GitBook, Docusaurus, Mintlify, Notion or Markdown.',
    category: 'Start',
    path: '/getting-started/import/',
    places: ['import'],
  },
  {
    title: 'Draft, review and publish',
    description: 'Understand drafts, staged changes, review and what readers see.',
    category: 'Write and publish',
    path: '/writing/draft-review-publish/',
    places: ['pages', 'home'],
  },
  {
    title: 'Organize pages and navigation',
    description: 'Build a navigation readers can scan and keep old links working.',
    category: 'Write and publish',
    path: '/writing/navigation/',
    places: ['pages', 'redirects'],
  },
  {
    title: 'Brand your published site',
    description: 'Set the logo, colors, typography, social image and custom domain.',
    category: 'Manage',
    path: '/manage/branding/',
    places: ['settings'],
  },
  {
    title: 'People, roles and permissions',
    description: 'Invite collaborators and decide who can write, review and publish.',
    category: 'Manage',
    path: '/manage/people-and-roles/',
    places: ['settings'],
  },
  {
    title: 'Understand Pulse and analytics',
    description: 'Find stale pages, failed searches and gaps readers expose.',
    category: 'Manage',
    path: '/manage/pulse-and-analytics/',
    places: ['pulse', 'analytics', 'search'],
  },
  {
    title: 'Use the Staleless CLI',
    description: 'Lint documentation and detect affected pages locally and in CI.',
    category: 'Developers',
    path: '/developers/cli/',
    places: ['developers'],
  },
  {
    title: 'Connect Staleless MCP',
    description: 'Give an AI agent scoped access to read and draft documentation.',
    category: 'Developers',
    path: '/developers/mcp/',
    places: ['developers'],
  },
]

export const guideUrl = (guide: ClientGuide): string => `${DOCS_BASE}${guide.path}`

export function guidesFor(place: Place): ClientGuide[] {
  return CLIENT_GUIDES.filter((guide) => guide.places.includes(place)).slice(0, 3)
}
